import type { FC } from 'react';

import { useParams } from '@xing-com/crate-core-router';

import { SubtopicPage as Subtopic } from './subtopic-page';

export const Component: FC = (): JSX.Element => {
  const { topicKey } = useParams();

  return <Subtopic {...{ topicKey }} />;
};
